module.exports = __webpack_public_path__ + "static/media/baetz.70fc1717.PNG";